import axios from "axios";
import * as apiConstants from "../constants/api-endpoint";
import * as auth from "../auth/temp-auth";

const reqHeaders = {
  "Content-Type": "application/json;charset=UTF-8 ",
};

export const postApiCall = async (bodydata: any) => {
  return axios.create();
};

export const sendPostRequest = (apiEndpoints: string, reqData: any) => {
  const authReqHeaders = {
    Authorization: "Bearer" + " " + localStorage.getItem("authToken")
  };
  
  return axios({
    url: apiConstants.devUrl + apiEndpoints,
    method: "POST",
    data: reqData,
    headers: reqHeaders,
  }).then((response) => {
    console.log(response);
    return response;
  });
};

export const sendGetRequest = (apiEndpoints: string, reqData: any) => {
  const authReqHeaders = {
    Authorization: "Bearer" + " " + localStorage.getItem("authToken")
  };
  
  return axios({
    url: apiConstants.devUrl + apiEndpoints,
    method: "GET",
    data: reqData,
    headers: reqHeaders,
  }).then((response) => {
    console.log(response);
    return response;
  });
};

export const authPostRequest = (apiEndpoints: string, reqData: any) => {
  const authReqHeaders = {
    Authorization: "Bearer" + " " + localStorage.getItem("authToken")
  };
  
  return axios({
    url: apiConstants.devUrl + apiEndpoints,
    method: "POST",
    data: reqData,
    headers: authReqHeaders,
    
  }).then((response) => {
    console.log(response);
    return response;
  });
};


export const authGetRequest = (apiEndpoints: string, reqData: any) => {
  const authReqHeaders = {
    Authorization: "Bearer" + " " + localStorage.getItem("authToken")
  };
  
  const header = authReqHeaders;
  return axios({
    url: apiConstants.devUrl + apiEndpoints,
    method: "GET",
    headers: header,
  }).then((response) => {
    console.log(response);
    return response;
  });
};





